import CreditCardIcon from '@mui/icons-material/CreditCard';
import StripePaymentsList from './StripePaymentsList';

export default {
  list: StripePaymentsList,
  icon: CreditCardIcon,
  options: { label: 'Stripe' },
};
